var _path, _path2, _g, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 62,
    viewBox: "0 0 101 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.8628 30.0001L71.7299 45.976C71.4464 46.615 70.8074 47.02 70.1098 47.02C69.9838 47.02 69.8578 47.002 69.7318 46.9885C68.9173 46.8085 68.3277 46.0795 68.3277 45.2469V34.5993H62.9769C62.3739 34.5993 61.8159 34.2978 61.4784 33.7803C61.1588 33.2898 61.1048 32.6417 61.3568 32.0972L68.4852 16.1213C68.8273 15.3608 69.6418 14.9288 70.4833 15.1088C71.2979 15.2888 71.8919 16.0178 71.8919 16.8504V27.498H77.2382C77.8458 27.498 78.4038 27.795 78.7368 28.317C79.0563 28.8075 79.1148 29.4556 78.8628 30.0001Z",
    fill: "#2196F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_10072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 94,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29541 0.874512H100.5V61.2228H7.29541V0.874512Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_10072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1098 54.1214C57.3291 54.1214 46.9335 43.7709 46.9335 31.0487C46.9335 18.3265 57.3291 7.9759 70.1098 7.9759C82.886 7.9759 93.2861 18.3265 93.2861 31.0487C93.2861 43.7709 82.886 54.1214 70.1098 54.1214ZM70.1098 0.874512H21.9752C21.0256 0.874512 20.1346 1.25253 19.4595 1.92307C18.7845 2.59361 18.4065 3.48465 18.4065 4.42521C18.4065 6.38281 20.0176 7.9759 21.9752 7.9759C22.9562 7.9759 23.7573 8.77244 23.7573 9.749C23.7573 10.7301 22.9562 11.5266 21.9752 11.5266H11.2781C10.3285 11.5266 9.43749 11.9001 8.76246 12.5707C8.08742 13.2457 7.7139 14.1322 7.7139 15.0728C7.7139 17.0304 9.31599 18.6235 11.2781 18.6235H39.7332C40.1427 18.592 40.5882 18.6955 40.9437 18.9655C41.5648 19.42 41.8348 20.2391 41.5648 20.9681C40.9797 22.6512 40.5207 24.4288 40.2282 26.2379C40.0752 27.1469 39.2651 27.795 38.3201 27.7275C38.0546 27.6915 37.8025 27.624 37.5955 27.498H25.5394C24.5943 27.498 23.7033 27.8715 23.0237 28.5465C22.3487 29.2171 21.9752 30.1036 21.9752 31.0487C21.9752 33.0018 23.5818 34.5994 25.5394 34.5994H38.0411C38.1221 34.5769 38.2346 34.5634 38.3381 34.5408C39.2651 34.4733 40.0887 35.0629 40.2462 35.9629C40.5342 37.727 40.9797 39.4596 41.5648 41.1292C41.8348 41.8582 41.5828 42.6728 40.9662 43.1543C40.5477 43.4513 40.0527 43.5638 39.5846 43.4738H11.2781C9.31599 43.4738 7.7139 45.0669 7.7139 47.02C7.7139 47.9651 8.08742 48.8516 8.76246 49.5267C9.43749 50.1972 10.3285 50.5707 11.2781 50.5707H21.9752C22.9562 50.5707 23.7573 51.3673 23.7573 52.3483C23.7573 53.3249 22.9562 54.1214 21.9752 54.1214C20.0176 54.1214 18.4065 55.7145 18.4065 57.6721C18.4065 58.6127 18.7845 59.4992 19.4595 60.1742C20.1346 60.8448 21.0256 61.2228 21.9752 61.2228H70.1098C86.8147 61.2228 100.414 47.6816 100.414 31.0487C100.414 14.4158 86.8147 0.874512 70.1098 0.874512Z",
    fill: "#2196F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19_10072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 27,
    width: 12,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 27.444H11.9036V35.5084H0.5V27.444Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19_10072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71388 34.5993C9.67599 34.5993 11.2781 33.0017 11.2781 31.0486C11.2781 29.0955 9.67599 27.4979 7.71388 27.4979H4.14519C2.18308 27.4979 0.580994 29.0955 0.580994 31.0486C0.580994 33.0017 2.18308 34.5993 4.14519 34.5993H7.71388Z",
    fill: "#2196F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.d8a9555400b9664813ec83f45326ec3f.svg";
export { ForwardRef as ReactComponent };